<div class="passport-qr">
  <!-- <ci-icon-button
    class="passport-qr__close"
    type="tonal"
    name="close"
    scale="1x"
    (click)="close()"
  ></ci-icon-button> -->

  <h6 class="passport-qr__title ci-heading-h6-bold">
    {{ 'Continúa en tu móvil' | translate }}
  </h6>

  @if (qr()) {
    <img class="passport-qr__image" [src]="qr()" alt="QR code" />
  }
</div>
